import styled from 'styled-components';
import { vars, fontWeight, media, pxToRem, defaultBorderRadius } from '$util/theme';

export default styled.div`
  /* width: 660px !important;
  .ant-modal-footer button {
    display: flex;
    justify-content: center;
  } */
  .StepCard {
    &:nth-child(1),
    &:nth-child(2) {
      padding-bottom: 20px;
      border-bottom: 1px solid ${vars.quantumverse.reskinColors.brandLightGray};
    }
    &:nth-child(2),
    &:nth-child(3) {
      padding-top: 20px;
    }
  }
`;

export const Card = styled.div`
  display: flex;
  .left {
    width: 40%;
    ${media.up('lg')} {
      width: 30%;
    }
    img {
      border-radius: ${defaultBorderRadius};
      ${media.down('md')} {
        height: 120px;
        object-fit: cover;
      }
    }
  }
  .right {
    width: 60%;
    margin-left: 15px;
    ${media.up('lg')} {
      width: 70%;
    }
    .title {
      font-size: ${pxToRem(16)};
      line-height: ${pxToRem(17)};
      font-weight: ${fontWeight.semiBold};
      margin-bottom: 5px;
      ${media.up('md')} {
        font-weight: 500;
        font-size: ${pxToRem(23)};
        line-height: ${pxToRem(23)};
      }
    }
    .content {
      font-size: ${pxToRem(14)};
      line-height: ${pxToRem(17)};
      ${media.up('md')} {
        font-size: ${pxToRem(17)};
        line-height: ${pxToRem(24)};
      }
    }
  }
`;
